import './HomeComponents.css';

interface ServicesSectionProps {
  id?: string;
}

const ServicesSection = ({ id }: ServicesSectionProps) => {
  const services = [
    { icon: "🏠", title: "Home Services", description: "Cleaning, gardening, plumbing, electrical work and more home maintenance tasks" },
    { icon: "🛒", title: "Errands & Shopping", description: "Grocery shopping, picking up packages, dropping off documents - we got you covered" },
    { icon: "📦", title: "Delivery", description: "Fast and reliable delivery for your packages, food, and items of any size" },
    { icon: "🚗", title: "Transportation", description: "Need a ride? Connect with reliable drivers for safe and comfortable travel" },
    { icon: "💼", title: "Professional Help", description: "Find skilled professionals for tutoring, tech support, beauty services and more" },
    { icon: "✨", title: "Custom Tasks", description: "Any other task you need help with - just post it and helpers will respond" },
  ];

  return (
    <section className="services" id={id}>
      <div className="section-header">
        <h2>What can Olitask help you with?</h2>
        <p>From everyday tasks to specialized services — find the right helper for any job</p>
      </div>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;